// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"dcb43208a51151f1102f","368":"7a1bbfd01c39420533d4","691":"7569700f4ded4ecf9736"}[chunkId] + ".js";
};